import * as types from 'actions/actionTypes';
import initialState from '../initialState';

/**
 * reducer per gestire le interrogazioni a crashboxx - download lista csv
 * @param {*} state
 * @param {*} action
 */
export default function crashboxxDownloadAllListCsvReducer(state = initialState.crashboxxFiles.allListCsv, action){

    switch(action.type)
    {
        case types.DOWNLOAD_ALLLISTCSV_REQUEST:
            return {...state, error: null, isLoading: true};
        case types.DOWNLOAD_ALLLISTCSV_SUCCESS:
            return {...state, error: null, isLoading: false};
        case types.DOWNLOAD_ALLLISTCSV_ERROR:
            return {...state, error: action.error, isLoading: false};
        default:
            return state;
    }
}


// WEBPACK FOOTER //
// ./src/reducers/crashboxx/crashboxxDownloadAllListCsvReducer.js